// The Qlik Cloud Amazon S3 V2 data connection every onGuard Qlik app loads
// from (ENTRAID-282). One name for the setup steps in the portal's Qlik
// Cloud section (pages/CustomerQlik.jsx) and for the Data reference script
// samples (data-catalog.mjs), so a sample pasted into an app works as is and
// the distributed apps find the connection the customer created.
//
// A fixed contract, confirmed by Hugo Andrade on 2026-09-29: the onGuard
// Qlik apps load from a connection with exactly this name. Changing it
// breaks every customer's app reload; never change it without a migration.
export const QLIK_S3_CONNECTION_NAME = 'onGuard_EntraID';

// In a shared or managed space Qlik Cloud names a connection
// `<space name>:<connection name>` in a script (help.qlik.com, "Connect to
// data sources in load scripts"). The space is the customer's own choice, so
// samples show this placeholder for it.
export const QLIK_SPACE_PLACEHOLDER = '<space name>';

/**
 * The `lib://` path of a file in the onGuard bucket, as a load script in the
 * space that holds the connection writes it.
 * @param {string} path - the S3 key under the bucket, e.g. entra-id/users/_latest.json
 * @param {{ space?: string|null }} [options] - null for a personal space (no prefix)
 */
export function qlikLibPath(path, { space = QLIK_SPACE_PLACEHOLDER } = {}) {
  const prefix = space ? `${space}:` : '';
  return `lib://${prefix}${QLIK_S3_CONNECTION_NAME}/${String(path).replace(/^\/+/, '')}`;
}

// The first load check the setup steps end with: one snapshot, one line.
export const QLIK_FIRST_LOAD_SAMPLE = `Users:\nLOAD * FROM [${qlikLibPath('entra-id/users/_latest.json')}] (json);`;
